import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SummaryReportComponent } from '@app/main/summary-report/summary-report.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [{ path: '', component: SummaryReportComponent, canActivate: [MsalGuard] }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SummaryReportRoutingModule {}
